import React from 'react';
import { ChefHat } from 'lucide-react';
// import { COMPANY_INFO } from '../../constants';
import logo from '../../assets/images/stoveShare.png';


const FooterLink = ({ label, onClick, href }) => {
  const cls = 'hover:text-red-600 transition-colors cursor-pointer';
  return href ? (
    <li><a href={href} className={cls}>{label}</a></li>
  ) : (
    <li><button onClick={onClick} className={cls}>{label}</button></li>
  );
};

const Footer = ({ onNavigate }) => (
  <footer className="bg-white border-t border-gray-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid md:grid-cols-4 gap-8">

        {/* Brand */}
        <div className="md:col-span-2">
           <button onClick={() => onNavigate('home')}
            className="flex items-center space-x-2 mb-4">
            <img
              src={logo}
              alt="StoveShare"
              className="w-8 h-8 object-contain rounded-full"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <ChefHat className="w-8 h-8 text-red-500 hidden" />
            <span className="text-2xl font-bold bg-gradient-to-r from-red-600 to-red-400 bg-clip-text text-transparent">
              StoveShare
            </span>
          </button>
          <p className="text-gray-600 mb-4 text-sm leading-relaxed">
            Connecting food creators with kitchen spaces to build thriving culinary communities across Australia.
          </p>
          <div className="text-xs text-gray-400">
            © {new Date().getFullYear()} StoveShare. Coming Soon.
          </div>
        </div>

        {/* Platform */}
        <div>
          <h4 className="font-semibold mb-4 text-gray-900 text-sm uppercase tracking-wide">Platform</h4>
          <ul className="space-y-2 text-gray-600 text-sm">
            <FooterLink label="How It Works"      onClick={() => onNavigate('home')} />
            <FooterLink label="Kitchen Owner Requirements" onClick={() => onNavigate('kitchenrequirements')} />
            <FooterLink label="For Food Creators"  onClick={() => onNavigate('home')} />
            <FooterLink label="About Us"           onClick={() => onNavigate('about')} />
              
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="font-semibold mb-4 text-gray-900 text-sm uppercase tracking-wide">Legal</h4>
          <ul className="space-y-2 text-gray-600 text-sm">
            <FooterLink label="Terms of Service"   onClick={() => onNavigate('terms')} />
            <FooterLink label="Privacy Policy"     onClick={() => onNavigate('privacy')} />
            {/* <FooterLink label="Cancellation Policy" onClick={() => onNavigate('cancellation')} /> */}
            {/* <FooterLink label="Damage & Incident Policy"  onClick={() => onNavigate('damage')} /> */}
             <li className="space-y-1">
              <p className="text-gray-700 text-xs">Contact Us</p>
              {/* <p className="text-gray-700 font-medium select-all">info@stoveshare.com.au</p> */}
              <a
                href="mailto:info@stoveshare.com.au"
                className="text-xs text-gray-700 hover:text-red-700 transition-colors"
              >
               info@stoveshare.com.au
              </a>
            </li>
   
           
          </ul>
        </div>

      </div>
    </div>
  </footer>
);

export default Footer;
